import FF from "@/components/forms/FormField.module.css";

import { WRadio } from "@/components/forms/WRadio.tsx";
import { MetalStatusBadge } from "@/modules/metal/status/MetalStatus.tsx";
import type { MetalStatusItem } from "@/modules/metal/status/StatusLabels.tsx";
import { cn } from "@/utils/classNames.ts";
import type { MetalStatus } from "@warrenio/api-spec/spec.oats.gen";
import { RadioGroup } from "react-aria-components";

interface StatusSelectorProps {
    items: MetalStatusItem[];
    value: MetalStatus;
    onChange: (value: MetalStatus) => void;
}

export function StatusSelector({ items, value, onChange }: StatusSelectorProps) {
    const radios = items
        .filter((item) => item.id !== "deleted")
        .map((item) => {
            const { id, description } = item;
            return (
                <WRadio
                    key={id}
                    value={id}
                    badge={<MetalStatusBadge reverse={value === id} value={id} />}
                    description={description}
                />
            );
        });

    return (
        <RadioGroup
            aria-label="Select machine status"
            className={cn(FF.FormFieldRadioGroup, "sm:grid-auto-flow-col mt-1 min-w-xs")}
            value={value}
            onChange={(v) => onChange(v as MetalStatus)}
        >
            {radios}
        </RadioGroup>
    );
}
